import { DecisionTree, type InteractiveUiConfig } from '@knolskape/educate-components';
import type { EducateModule } from '@/hooks/useEducateModule';
import { useProductHost } from '../../host/useProductHost';

export const DecisionTreeHost = ({ module }: { module: EducateModule }) => {
  // Identity unit mapping: the branching engine already emits `node-<id>` ids
  // that match 4e's decision-tree units.
  const props = useProductHost(module, { identity: true });
  if (!props) return null;
  return (
    <DecisionTree
      config={props.config as InteractiveUiConfig}
      content={props.content}
      mode="play"
      host={props.host}
      storylineId={props.storylineId}
    />
  );
};
